import { SubEntityType, Video } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getVideoById = async (
  groupId: number,
  videoId: string,
  locale: string
): Promise<Video | null> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.Videos}/id/${videoId}?marketLocale=${encodeURIComponent(locale)}`;
    const response = await knowledgeBaseHttp.get<Video>(url);
    return response?.data || null;
  } catch (error) {
    console.error(`Error fetching videos:`, error);
    return null;
  }
};
